__turbopack_context__.v({
  "themeZone": "RecoveryThemeTransition-module__ZbGOia__themeZone",
});
